<!-- Chatbot Popup -->
<div class="chat-popup">

  <!-- Header -->
  <div class="chat-header">
    <h1>SIMI - AI Assistant</h1>
    <button class="close-btn" (click)="closeDialog()">
      <i class="bi bi-x"></i>
    </button>
  </div>

  <!-- Chat Body -->
  <div class="chat-body" #chatBody>
    <div *ngFor="let msg of messages; let i = index">

      <!-- User Message -->
      <div *ngIf="msg.sender === 'user'" class="message-row user">
        <div class="message-bubble">
          <strong>{{ msg.text }}</strong>
        </div>
        <div class="timestamp">{{ msg.timestamp }}</div>
      </div>

      <!-- AI Text Message -->
      <div *ngIf="msg.sender === 'ai' && msg.text" class="message-row ai">
        <div class="message-bubble">
          {{ msg.text }}
        </div>
        <div class="timestamp">{{ msg.timestamp }}</div>
      </div>

      <!-- AI Table Message -->
      <div *ngIf="msg.sender === 'ai' && msg.table?.data && msg.table?.columns" class="report-card">
        <div class="report-title d-flex justify-content-between">
          <div>📋 Report:</div>
          <div>
            <button mat-icon-button (click)="openTablePopup(msg.table)" title="Expand" class="expand-icon-btn">
              <mat-icon>zoom_out_map</mat-icon>
            </button>
          </div>
        </div>

        <table class="report-table">
          <thead>
            <tr>
              <th *ngFor="let col of msg.table?.columns">{{ col }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of msg.table?.data">
              <td *ngFor="let col of msg.table?.columns">
                <ng-container *ngIf="row[col].isImage; else textTemplate">
                  <img [src]="row[col].value" alt="Image" width="60" height="60" />
                </ng-container>
                <ng-template #textTemplate>
                  {{ row[col].value }}
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>

        <span class="timestamp">{{ msg.timestamp }}</span>
      </div>

      <!-- Chart Preference Options -->
      <ng-container *ngIf="messages.length - 1 === i">
        <div class="quick-options mt-3" *ngIf="msg.question === 'chart'">
          <button (click)="handleChartPreference(true)">Yes</button>
          <button (click)="handleChartPreference(false)">No</button>
        </div>
      </ng-container>

      <!-- Chart Select Boxes -->
      <ng-container *ngIf="msg.selectBox && messages.length - 1 === i">
        <div class="message-row ai">
          <div class="message-bubble">
            Please select a chart type along with both X and Y axes to proceed.
          </div>
          <div class="timestamp">{{ msg.timestamp }}</div>
        </div>

        <div class="chart-options d-flex align-items-center gap-2" [ngClass]="{ 'disabled-input': isLoading }">
          <div class="form-group flex-fill">
            <select [(ngModel)]="selectedChartType" class="form-select form-select-sm"
              (change)="onChartOptionChange(i)">
              <option value="" disabled selected hidden>Type</option>
              <option *ngFor="let type of chartTypes" [value]="type">{{ type | titlecase }}</option>
            </select>
          </div>

          <div class="form-group flex-fill">
            <select [(ngModel)]="selectedXAxis" class="form-select form-select-sm" (change)="onChartOptionChange(i)">
              <option value="" disabled selected hidden>X axis</option>
              <option *ngFor="let col of msg?.table?.columns" [value]="col">{{ col }}</option>
            </select>
          </div>

          <div class="form-group flex-fill">
            <select [(ngModel)]="selectedYAxis" class="form-select form-select-sm" (change)="onChartOptionChange(i)">
              <option value="" disabled selected hidden>Y axis</option>
              <option *ngFor="let col of msg?.table?.columns" [value]="col">{{ col }}</option>
            </select>
          </div>
        </div>
      </ng-container>

      <!-- AI Graph Response -->
      <ng-container *ngIf="msg.sender === 'ai' && msg?.graph?.length">
        <div *ngFor="let g of msg.graph; let i = index" class="report-card chart mt-2">
          <div class="d-flex justify-content-between align-items-center">
            <div class="report-title">📊 Graph-{{ i + 1 }}</div>
            <button mat-icon-button (click)="openChartPopup(g)" title="Expand" class="expand-icon-btn">
              <mat-icon>zoom_out_map</mat-icon>
            </button>
          </div>
          <div class="mt-1">
            <plotly-plot [data]="g.data" [layout]="g.layout"></plotly-plot>
          </div>
          <span class="timestamp">{{ msg.timestamp }}</span>
        </div>
      </ng-container>

      <!-- Loading Indicator -->
      <div *ngIf="isLoading && messages.length - 1 === i" class="loading-container">
        <div class="loading-text">Loading</div>
        <div class="dot-loader">
          <span>.</span><span>.</span><span>.</span>
        </div>
      </div>

    </div>
  </div>

  <!-- Suggestions -->
  <div class="quick-options mt-3" [ngClass]="{ 'disabled-input': isLoading }">
    <button *ngFor="let question of suggestions" (click)="useSuggestion(question)">
      {{ question }}
    </button>
  </div>

  <!-- Input Row -->
  <div class="input-row">
    <input type="text" placeholder="Ask about any questions" [(ngModel)]="userInput"
      (keyup.enter)="onSendButtonClick()" />
    <button [disabled]="isLoading">
      <i class="bi bi-send-fill" (click)="onSendButtonClick()"></i>
    </button>
  </div>

</div>